module.exports = __webpack_public_path__ + "img/view_white.89fd4554.svg";